import { Component, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store';
import { ContactService } from '../../../data/contact.service';
import { TableColumnService } from '../../shared/services/table-column.service';
import { ContactsData } from './contacts.data';
import { contactDeleteRequest, contactsTableRequest } from '../../../store/contacts-table/contacts-table.actions';
import { Contact } from '../../../models/contact';
import { ContactEditComponent } from '../contact-edit/contact-edit.component';
import { ContactsTableService } from '../../shared/tables/contacts-table.service';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatAnchor, MatButton } from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import {
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow
} from '@angular/material/table';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { AsyncPipe } from '@angular/common';
import { contactEditorEdit, contactEditorLoadRequest } from '../../../store/contact-editor/contact-editor.actions';
import { ConfirmService } from '../../shared/services/confirm.service';

@Component({
    selector: 'app-contacts-table',
    templateUrl: './contacts-table.component.html',
    styleUrls: [ './contacts-table.component.scss' ],
    imports: [ MatProgressSpinner, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCheckbox, MatCellDef, MatCell,
        MatSortHeader, MatAnchor, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator, AsyncPipe, MatButton ]
})
export class ContactsTableComponent implements OnInit {

    constructor(private store: Store<AppState>, private contactService: ContactService,
                private tableColumnService: TableColumnService, private dialog: MatDialog,
                public table: ContactsTableService, private confirmService: ConfirmService) {
    }

    @ViewChild(MatPaginator) paginator: MatPaginator;

    dataSource = new ContactsData(this.table.currentPageEntries$);

    ngOnInit(): void {
        this.store.dispatch(contactsTableRequest());
    }

    edit(id: string): void {
        this.store.dispatch(contactEditorEdit({ id }));
    }

    delete(): void {
        const count = this.table.selection().length;
        this.confirmService.confirm(
            $localize`Delete ${count} contact(s)?`,
            $localize`Are you sure you wish to delete the selected contacts?  This cannot be reversed.`,
            () => this.store.dispatch(contactDeleteRequest())
        );
    }

}
